/**
 * Class for generating skip links
 * @abstract
 * @class
 */
export class SkipLinks {
    /**
     * Generate skip links HTML, hook a11y logic and append it to HTML
     * @public
     * @static
     * @method
     */
    static generate() {
        const skipNavContainer = document.createElement("div");
        skipNavContainer.setAttribute("id", SkipLinks.SKIP_LINKS_CONTAINER_ID);
        // build skip link for each attribute hook in the page
        document.querySelectorAll(`[${SkipLinks.SKIP_LINK_ATTRIBUTE}]`).forEach((el) => {
            var _a;
            const data = (_a = el.getAttribute(SkipLinks.SKIP_LINK_ATTRIBUTE)) !== null && _a !== void 0 ? _a : "";
            if (data) {
                const btn = document.createElement("BUTTON");
                btn.setAttribute("type", "button");
                btn.innerText = `Skip to ${data}`;
                btn.addEventListener("click", () => {
                    el.setAttribute("tabindex", "-1");
                    el.focus();
                });
                const span = document.createElement("SPAN");
                span.classList.add(SkipLinks.SHOW_FOR_SR_CLASS);
                span.innerHTML = `&nbsp;(${SkipLinks.SAME_PAGE_LINK_LABEL})`;
                btn.append(span);
                skipNavContainer.append(btn);
            }
        });
        document.body.prepend(skipNavContainer);
    }
}
SkipLinks.SAME_PAGE_LINK_LABEL = "Same page link";
SkipLinks.SHOW_FOR_SR_CLASS = "show-for-sr";
SkipLinks.SKIP_LINKS_CONTAINER_ID = "accessibility-skip-links";
SkipLinks.SKIP_LINK_ATTRIBUTE = "data-skip-link"; // attribute that needs to be added to each element that should become skip link, the value of the attribute is pretty name of the section/element for screen reader
